import {AutogenLayoutSubmittalExceptionPanel} from "./autogen/AutogenLayoutSubmittalExceptionPanel";

export class SubmittalExceptionPanel extends AutogenLayoutSubmittalExceptionPanel
{

}
